import React from 'react'

export function PageNotFound({ location, text }) {
    return (
        <div className="PageError">
            {text ? (
                <h1 className="mt-5">{text}</h1>
            ) : (
                <h1 className="mt-5">
                    404. No match for <strong>{location.pathname}</strong>
                </h1>
            )}
        </div>
    )
}



// WEBPACK FOOTER //
// src/pages/Errors/PageNotFound/PageNotFound.js